import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import NProgress from 'nprogress';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FaMoon, FaSun, FaHome, FaPaperPlane, FaHistory, FaGavel, FaKey, FaUserCircle, FaSignOutAlt, FaLifeRing, FaUpload } from 'react-icons/fa';
import { FaWalkieTalkie } from 'react-icons/fa6';


const Dashboard = () => {
    const { user } = useContext(AuthContext);
    const [stats, setStats] = useState({
        totalSent: 0,
        todaySent: 0,
        pendingSMS: 0
    });
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.115.9:3000/api';

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                NProgress.start();
                const res = await axios.get(`${API_URL}/user/stats`);
                setStats(res.data);
            } catch (err) {
                console.error("Dashboard stats error:", err);
                toast.error("Statistikany ýükläp bolmady");
            } finally {
                setLoading(false);
                NProgress.done();
            }
        };

        fetchDashboardData();
    }, [API_URL]);

    return (
        <>
            <Helmet>
                <title>SMS Serwis - Baş sahypa</title>
            </Helmet>



            <div className="bg-white rounded-lg shadow p-6 mb-6">
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-semibold text-gray-800">Salam, {user?.companyName || user?.phone}!</h2>
                    <div className="text-lg font-medium text-indigo-600">
                        Balans: {Number(user?.balance).toFixed(2)} TMT
                    </div>
                </div>
                <p className="text-gray-600 mb-4">
                    SMS hyzmatlary platformasyna hoş geldiňiz. Bu ýerde SMS ugradyp,
                    olary dolandyryp we API üçin tokenlar döredip bilersiňiz.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Total sent SMS */}
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg shadow p-6 text-white">
                    <div className="flex justify-between items-start">
                        <div>
                            <div className="text-3xl font-bold mb-2">
                                {loading ? "..." : stats.totalSms}
                            </div>
                            <div className="text-sm opacity-80 uppercase tracking-wide">
                                Jemi ugradylan SMS
                            </div>

                        </div>
                        <FaPaperPlane />
                    </div>
                </div>

                {/* Today sent SMS */}
                <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-lg shadow p-6 text-white">
                    <div className="flex justify-between items-start">
                        <div>
                            <div className="text-3xl font-bold mb-2">
                                {loading ? "..." : stats.todaySentSms}
                            </div>
                            <div className="text-sm opacity-80 uppercase tracking-wide">
                                Bu gün ugradylan SMS
                            </div>
                        </div>

                        <FaHistory />
                    </div>
                </div>

                {/* Pending SMS */}
                <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-lg shadow p-6 text-white">
                    <div className="flex justify-between items-start">
                        <div>
                            <div className="text-3xl font-bold mb-2">
                                {loading ? "..." : stats.pendingSms}
                            </div>
                            <div className="text-sm opacity-80 uppercase tracking-wide">
                                Garaşýan SMS-ler
                            </div>
                        </div>
                        <FaUpload />
                    </div>
                </div>
            </div >

            <div className="mt-6 bg-white rounded-lg shadow p-6">
                <h2 className="text-lg font-medium text-gray-900 mb-4">SMS Hyzmatlary barada</h2>
                <div className="space-y-4">
                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-indigo-100 rounded-full p-2">
                            <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                            </svg>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-md font-medium text-gray-900">SMS ugrat</h3>
                            <p className="text-sm text-gray-500">
                                SMS ugratmak üçin "SMS Ugrat" bölümine geçiň. Her bir SMS 0.50 TMT.
                                Balans ýeterlik bolmasa SMS ugradyp bolmaýar.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-indigo-100 rounded-full p-2">
                            <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                            </svg>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-md font-medium text-gray-900">SMS Taryhy</h3>
                            <p className="text-sm text-gray-500">
                                Ähli ugradylan SMS-leriň taryhyny "SMS Taryhy" bölüminde görüp bilersiňiz.
                                Her bir SMS-iň statusyny hem görüp bilersiňiz.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-start">
                        <div className="flex-shrink-0 bg-indigo-100 rounded-full p-2">
                            <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-md font-medium text-gray-900">API üçin Token</h3>
                            <p className="text-sm text-gray-500">
                                Programma integrasiýasy üçin ýörite API tokenyny "Token döret"
                                bölüminde döredip bilersiňiz. Programmistler üçin ähli maglumatlar şol ýerde berilen.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;